import { Directive, EventEmitter, Output, OnInit, HostListener, ElementRef } from '@angular/core';
declare var $:any;
@Directive({
  selector: '[appHScroll]'
})
export class HScrollDirective implements OnInit {
  @Output('appHScroll') appHScroll: EventEmitter<any> = new EventEmitter();
  constructor(private el: ElementRef) {
  }
  ngOnInit(): void {
    setTimeout(() => this.appHScroll.emit('loaded'), 10);
  }
}
